// React
import PropTypes from "prop-types";

// APIs
import { useMultiRegionTPI } from "../../api/tender-price-index/TenderPriceIndexingAPI";
import {
  useLocationFactors,
  useLocations,
} from "../../api/admin/RegionManagementAPI";
import { useCurrencyExchange } from "../../api/admin/CurrencyExchangeAPI";
import { getBenchmarkWithRows } from "../../api/benchmarking/BenchmarkingAPI";

// Components
import BenchmarkSection from "../benchmarking-project/BenchmarkSection.components";
import BenchmarkCreateAnalysisDisclaimer from "../benchmarking/BenchmarkingDisclaimer/BenchmarkCreateAnalysisDisclaimer";

// Functions
import { extractYearFromISODateString } from "../../helpers/common.functions";
import isEmpty from "../../validation/is-empty";

BenchmarkCollectionsAnalysis.propTypes = {
  loadedCollection: PropTypes.object,
  setLoadedCollection: PropTypes.func,
  user: PropTypes.object,
  showDashboard: PropTypes.bool,
  setShowDashboard: PropTypes.func,
};

export default function BenchmarkCollectionsAnalysis(props) {
  const { loadedCollection, setLoadedCollection } = props;
  const { user } = props;
  const { showDashboard, setShowDashboard } = props;

  // APIs
  const { locationFactors } = useLocationFactors();
  const { locations } = useLocations(true);

  const { TPI } = useMultiRegionTPI(
    loadedCollection?.linked_benchmarks,
    locations?.data
  ); // Benchmarks
  const { currencyExchange } = useCurrencyExchange();

  const showDisclaimer = !isEmpty(loadedCollection);

  let thisBenchmark = loadedCollection?.linked_benchmarks?.[0];
  let benchmarks = loadedCollection?.linked_benchmarks?.slice(1);

  const disclaimerDisplay = {
    fields: [
      ["Project Function", loadedCollection?.sub_sector],
      ["Project Type", loadedCollection?.project_type],
      ["Quality Level", loadedCollection?.quality],
      ["Location", loadedCollection?.city],
      [
        "Escalation Year",
        extractYearFromISODateString(loadedCollection?.base_date),
      ],
      ["Currency", loadedCollection?.currency],
    ],
    fallbackValue: "-",
  };

  return (
    <div className="master-benchmarking">
      <BenchmarkCreateAnalysisDisclaimer
        disclaimerDisplay={disclaimerDisplay}
        show={showDisclaimer}
      />
      <BenchmarkSection
        // Caller
        caller={"MASTER_BENCHMARKING"}
        // Benchmark Data
        thisBenchmark={thisBenchmark}
        benchmarks={benchmarks}
        // General Data
        unitOfMeasure={loadedCollection?.unitOfMeasure}
        currencySymbol={loadedCollection?.currencySymbol}
        baseDate={loadedCollection?.base_date}
        // Location
        region={loadedCollection?.region}
        country={loadedCollection?.country}
        city={loadedCollection?.city}
        // Inflation Escalation
        TPI={TPI}
        // Locality Escalation
        LFI={locationFactors?.data}
        isLocalRegionFactorEnabled={loadedCollection?.localRegionFactor}
        is_locality_factor_active={false} // Cost Plan Locality Factor Override Toggle
        locality_factor={null} // Cost Plan Locality Factor Override Value
        // Currency Escalation
        isGlobalBenchmarking={loadedCollection?.currencyFactor}
        currencyExchange={currencyExchange?.data}
        currency={loadedCollection?.currency}
        // Dashboard
        showDashboard={showDashboard}
        setShowDashboard={setShowDashboard}
        moduleId={loadedCollection?.id}
        // User
        user={user}
        // Anonymisation
        linkedBenchmarksIds={loadedCollection?.linkedBenchmarksIds}
        linkedBenchmarksIdsParentId={loadedCollection?.id}
        linkedBenchmarks={loadedCollection?.linked_benchmarks} // This can be different depending on the location
        updateState={async () => {
          let collection = await getBenchmarkWithRows(loadedCollection?.id);
          setLoadedCollection(collection?.[0]);
        }}
      />
    </div>
  );
}
